/**
 * OpenAPI definition
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Override commission creation request
 */
export interface AccountPairOverrideRequest {
  accountId: number;
  pairId: number;
  /**
   * Commission for SELL client orders. Formula: \"1 = 0.1BPS = 0.001% = 0.00001\".
   */
  bidCommissionRate?: number;
  /**
   * Commission for BUY client orders. Formula: \"1 = 0.1BPS = 0.001% = 0.00001\".
   */
  askCommissionRate?: number;
  qtyLevelsTier?: AccountPairOverrideRequest.QtyLevelsTierEnum;
  active: boolean;
}
export namespace AccountPairOverrideRequest {
  export const QtyLevelsTierEnum = {
    Small: 'SMALL',
    Regular: 'REGULAR',
    Big: 'BIG',
  } as const;
  export type QtyLevelsTierEnum = (typeof QtyLevelsTierEnum)[keyof typeof QtyLevelsTierEnum];
}
